(() => {
  if (window.deinFriseurOpenAIAds) return;
  const config = document.querySelector('script[data-openai-ads]');
  const pixelId = config?.dataset.pixelId?.trim();
  if (!pixelId || window.Shopify?.designMode) return;

  let initialized = false;
  let viewed = false;
  let ownsPixel = false;

  function allowed() {
    const privacy = window.Shopify?.customerPrivacy;
    return privacy?.analyticsProcessingAllowed() === true && privacy?.marketingAllowed() === true;
  }

  function syncConsent() {
    try {
      const consent = allowed();
      if (!initialized && consent) {
        // Another integration must not be silently reconfigured or initialized twice.
        if (window.oaiq) return false;
        const queue = function () { queue.q.push(arguments); };
        queue.q = [];
        window.oaiq = queue;
        ownsPixel = true;
        window.oaiq('consent', false);
        window.oaiq('init', { pixelId });
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://bzrcdn.openai.com/sdk/oaiq.min.js';
        document.head.appendChild(script);
        initialized = true;
      }
      if (ownsPixel) {
        // Discard queued measurements on withdrawal, including while the SDK loads.
        if (!consent && Array.isArray(window.oaiq.q)) {
          window.oaiq.q = window.oaiq.q.filter((args) => args[0] !== 'measure');
        }
        window.oaiq('consent', consent);
      }
      return initialized && consent;
    } catch {
      return false;
    }
  }

  function measure(name, data) {
    try {
      if (!syncConsent()) return;
      window.oaiq('measure', name, data, {
        opt_out: window.Shopify.customerPrivacy.saleOfDataAllowed?.() !== true,
      });
    } catch {
      // Measurement must never interrupt shopping.
    }
  }

  function itemsAdded(items) {
    try {
      const contents = items
        .filter((item) => item.id && Number.isInteger(Number(item.quantity)) && Number(item.quantity) > 0)
        .map((item) => ({ id: String(item.id), quantity: Number(item.quantity), content_type: 'product' }));
      if (contents.length) measure('items_added', { type: 'contents', contents });
    } catch {
      // Ignore malformed or unavailable cart data.
    }
  }

  function pageViews() {
    try {
      if (!syncConsent() || viewed) return;
      viewed = true;
      measure('page_viewed', { type: 'contents' });
      if (config.dataset.productId) {
        measure('contents_viewed', {
          type: 'contents',
          contents: [{ id: config.dataset.productId, content_type: 'product' }],
        });
      }
    } catch {
      // Fail closed when the privacy API is unavailable.
    }
  }

  function previousQuantity(component, line) {
    try {
      const input = component.refs.quantitySelectors[line - 1]?.querySelector('input');
      return input ? Number(input.defaultValue) : undefined;
    } catch {
      return undefined;
    }
  }

  function quantityIncreased(cart, line, previous) {
    try {
      if (!Number.isInteger(previous) || previous < 1) return;
      const item = cart.items?.[line - 1];
      if (item) itemsAdded([{ id: item.variant_id, quantity: item.quantity - previous }]);
    } catch {
      // Only a confirmed positive quantity change is a cart addition.
    }
  }

  window.deinFriseurOpenAIAds = { itemsAdded, previousQuantity, quantityIncreased };
  document.addEventListener('cart:update', (event) => {
    try {
      const detail = event.detail;
      if (detail?.data?.source !== 'product-form-component' || detail.data.didError) return;
      itemsAdded([{ id: detail.sourceId, quantity: detail.data.itemCount }]);
    } catch {
      // Other cart publishers may use different event shapes.
    }
  });
  document.addEventListener('visitorConsentCollected', pageViews);
  document.addEventListener('shopify:consent:changed', pageViews);
  try {
    if (window.Shopify?.customerPrivacy) pageViews();
    else window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
      if (!error) pageViews();
    });
  } catch {
    // No consent API means no tracking.
  }
})();
